/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ZoomVideo from '@zoom/videosdk';
import { generateVideoToken } from '../do-not-close-screen/utils';

import { config } from '../../../../../../config';

import {
  Button,
  ButtonCancel,
  Container,
  ContainerButton,
  Title,
  Video,
  Description,
  Loader,
} from './styles';
import { RECORDER_STATUS } from '../../constants';

const HELP_CENTER_LINK = 'http://help.playbookux.com/en/articles/6725886-chrome-extension-permissions';

const ScreenShareCheck = (props) => {
  const {
    sessionId,
    setCurrentStep,
    STEPS,
    history,
    uri,
    setZoomClient,
    isSharing,
    status,
  } = props;
  const [error, setError] = useState(null);
  const screenRef = useRef(null);

  const handleStartShare = async () => {
    try {
      const zoom = ZoomVideo.createClient();
      setZoomClient(zoom);
      zoom.init('en-US', 'CDN');
      const sdkKey = config.REACT_APP_ZOOM_VIDEO_SDK_KEY;
      const sdkSecret = config.REACT_APP_ZOOM_VIDEO_SDK_SECRET;
      const topic = sessionId;
      const name = `Chrome-${Math.floor(Math.random() * 1000)}`;

      const signature = generateVideoToken(
        sdkKey,
        sdkSecret,
        topic,
      );
      await zoom.join(topic, signature, name);
      const stream = zoom.getMediaStream();
      await stream.startShareScreen(screenRef.current);
    } catch (e) {
      if (e.type === 'INVALID_OPERATION') {
        setError('Permissions was denied. Please enable screen recording from the system settings and try again. ');
      }
    }
  };

  const handleCancel = async () => {
    const zoom = ZoomVideo.createClient();
    const stream = zoom.getMediaStream();

    history.goBack();
    await stream.stopShareScreen();
    await zoom.leave();
  };

  const handleNextStep = () => {
    setCurrentStep(STEPS.DO_NOT_CLOSE);
    const data = {
      type: 'AUTHENTICATED_MESSAGE',
      content: {
        uri,
      },
    };
    window.postMessage(data, '*');
  };

  useEffect(() => {
    handleStartShare();
  }, []);

  useEffect(() => {
    if (status === RECORDER_STATUS.ABORTED) {
      setError('Error: screen share was stopped.');
    }
  }, [status]);

  return (
    <Container>
      <Title>Screen share check</Title>

      <Video ref={screenRef} isSharing={isSharing} />
      {(!isSharing && !error) && (
        <Loader data-loader="unmod-screen-share-loader" />
      )}
      {error && (
        <Description>
          {error}
          <a href={HELP_CENTER_LINK} target="_blank" rel="noopener noreferrer">Learn more here.</a>
        </Description>
      )}

      <ContainerButton>
        <ButtonCancel onClick={handleCancel}>
          Cancel
        </ButtonCancel>
        <Button onClick={handleNextStep} disabled={!isSharing}>
          Continue
        </Button>
      </ContainerButton>
    </Container>
  );
};

ScreenShareCheck.propTypes = {
  isSharing: PropTypes.bool.isRequired,
  sessionId: PropTypes.string.isRequired,
  setZoomClient: PropTypes.func.isRequired,
  zoomClient: PropTypes.shape({
    leave: PropTypes.func,
  }).isRequired,
  uri: PropTypes.string.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  STEPS: PropTypes.shape({
    DO_NOT_CLOSE: PropTypes.string,
  }).isRequired,
  status: PropTypes.string.isRequired,
};

export default ScreenShareCheck;
